import React from "react";
import { useQuery } from "@apollo/client";
import * as FoodsQL from "queries/foods";
import { formatNumber } from "components/day/summary";

// The remembered foods a typed name may mean: every word typed found in the
// food's name, as the start of one of its words ("oat" finds "oatmeal",
// "egg" finds "scrambled eggs"). With nothing typed, the most recent. At most
// `limit`.
export const matching = (foods = [], typed = "", limit = 6) => {
  const words = String(typed || "").toLowerCase().split(/\s+/).filter(Boolean);
  const hits = words.length
    ? foods.filter((f) => {
        const name = String(f.name || "").toLowerCase().split(/[^a-z0-9À-ɏ]+/);
        return words.every((w) => name.some((n) => n.startsWith(w)));
      })
    : foods;
  return hits.slice(0, limit);
};

// The add-food form's shortcut: a remembered food, one tap, and its serving
// and numbers fill the form, ready to change before Add.
export const FoodPicker = ({ typed, onPick }) => {
  const { data } = useQuery(FoodsQL.list, { fetchPolicy: "cache-and-network" });
  const foods = matching(data?.viewer?.account?.foods?.list || [], typed);
  if (!foods.length) return null;

  return (
    <div className="mb-3" data-testid={"food-picker"}>
      <div className="small text-muted mb-1">{typed ? "From what you've logged:" : "Logged recently:"}</div>
      <div className="d-flex flex-wrap">
        {foods.map((food) => (
          <button
            key={food.foodId}
            type={"button"}
            className="btn btn-outline-secondary btn-sm mr-2 mb-2"
            onClick={() => onPick(food)}
            data-testid={"food-picker-item"}
          >
            {food.name}
            {food.serving ? <span className="text-muted"> · {food.serving}</span> : null}
            <span className="text-muted"> · {formatNumber(food.calories)} kcal</span>
          </button>
        ))}
      </div>
    </div>
  );
};
